import { Dispatch } from "redux";
import { AxnAttributeType, FormattedAxnAttributeLabel } from "@idw-types/data/reference-data/axn";
import { setAttributeLabelDetails } from "@redux/actions/attribute-label-details-actions";
import { updateAxnAttributeLabelRequest } from "@requests/management-console/update-axn-attribute-label";
import { formatAxnAttributeLabel } from "@formatters/axn-attribute-labels/axn-attribute-label-formatter";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const updateAttributeLabelReduxRequest = (dispatch: Dispatch) => async (
    axnAttributeLabel: FormattedAxnAttributeLabel,
    axnAttributeTypes: Array<AxnAttributeType>
): Promise<FormattedAxnAttributeLabel> => {
    const { data, error, body} = await updateAxnAttributeLabelRequest(axnAttributeLabel);
    if (data?.transferObject) {
        const formattedAttributeLabel = formatAxnAttributeLabel(data.transferObject, axnAttributeTypes);
        dispatch(setAttributeLabelDetails(formattedAttributeLabel));
        displaySuccessModal(
            dispatch,
            resources.requests.updateAttributeLabel.success.title,
            resources.requests.updateAttributeLabel.success.message
        );
        return formattedAttributeLabel;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateAttributeLabel.error.title,
            resources.requests.updateAttributeLabel.error.message,
            null,
            null,
            body
        );
    }

    return null;
};